import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { AppView } from 'design-system';
import useColors from 'hooks/useColors';
import { rem } from 'design-system/values';
import Progress from 'design-system/Progress';
import EmojiText from 'design-system/EmojiText';
import DSStatusBar from 'design-system/StatusBar';
import Modal from 'utils/packages/Modal';
const strings = {
    done: 'Done!',
};
export const LoadingAppView = React.memo(({ isDone, title }) => {
    const colors = useColors();
    return (<AppView>
      <View style={styles.container}>
        <DSStatusBar animated barStyle="dark-content"/>
        {isDone ? (<>
            <EmojiText fontSize={rem(72)}>👊</EmojiText>
            <Text Text-32 centered>
              {strings.done}
            </Text>
          </>) : (<>
            <Progress style={styles.progress} color={colors.text.brand}/>
            {!!title && (<Text Text-20 centered>
                {title}
              </Text>)}
          </>)}
      </View>
    </AppView>);
});
const styles = StyleSheet.create({
    container: { flex: 1, justifyContent: 'center', alignItems: 'center' },
    progress: { width: rem(70), height: rem(70), marginBottom: rem(24) },
});
export const LoadingAppViewModal = {
    show: (props) => {
        Modal.show(<LoadingAppView {...props}/>, {
            fullscreen: true,
            nonDismissable: true,
            minShowTime: 1500,
            fade: true,
        });
    },
    hide: (cb) => Modal.hide(cb),
};
